import * as React from "react";
import { Stack, Grid } from "@mui/material";
import { HeaderNavProps } from "@/components/header/common/types";
import TertiaryNavItem from "@/components/header/navigation/desktop/_components/tertiary-navigation/tertiary-nav-item";

type TertiaryPaneContentWrappedProps = {
  tertiaryNavItems: HeaderNavProps[];
};
export default function TertiaryNavigationPaneContentWrapped(props: TertiaryPaneContentWrappedProps) {
  const { tertiaryNavItems } = props;

  return (    
    <Stack spacing={2} sx={{ justifyContent: "flex-end", flexWrap: "wrap", py: 2 }}>
      <Grid container spacing={2} sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)" }}>
        {Array.from(Array(Math.ceil(tertiaryNavItems.length / 8))).map((_, columnIndex) => (
          <Grid
            key={tertiaryNavItems[columnIndex * 8].sys.id} 
            sx={{               
              opacity: 0.8,
              gridColumn: `${columnIndex + 1}`
            }}>
            {tertiaryNavItems.slice(columnIndex * 8, (columnIndex + 1) * 8).map((item) => (
              <TertiaryNavItem key={item.sys.id} item={item} />
            ))}
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}
